module.exports = __webpack_public_path__ + "static/media/my-user-bg.470f4427.svg";